import React from 'react';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import nibSVG from '@plone/volto/icons/nib.svg';

export default function addStyleMenuFont(config) {
  const { slate } = config.settings;

  slate.styleMenu = slate.styleMenu || {};
  slate.styleMenu.inlineStyles =
    slate.styleMenu.inlineStyles || [];

  slate.styleMenu.inlineStyles.push(
    {
      cssClass: 'font-family-sans',
      label: 'Sans Serif',
      icon: () => (
        <Icon name={nibSVG} size="24px" />
      ),
    },
    {
      cssClass: 'font-family-serif',
      label: 'Serif',
      icon: () => (
        <Icon name={nibSVG} size="24px" />
      ),
    },
    {
      cssClass: 'font-family-mono',
      label: 'Monospace',
      icon: () => (
        <Icon name={nibSVG} size="24px" />
      ),
    },
    {
      cssClass: 'font-family-display',
      label: 'Display',
      icon: () => (
        <Icon name={nibSVG} size="24px" />
      ),
    },
  );

  return config;
}